<nes-text class="nes-mb-3" color="text-default">
  {{ "WIZARD_STEPPER.STEP" | translate }}
  {{ currentStepNumber }}
  {{ "WIZARD_STEPPER.OF" | translate }}
  {{ noOfSteps }}
</nes-text>
